import { MoreVertical, MoreHorizontal } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent
} from '@components/ui/dropdown-menu'

const OverflowMenu = ({ orientation = 'vertical', children, className, ...props }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center rounded-full hover:text-gray-600 focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100">
        <span className='sr-only'>Open options</span>

        <Choose>
          <When condition={orientation === 'horizontal'}>
            <MoreHorizontal className='h-6 w-6' aria-hidden='true' />
          </When>

          <Otherwise>
            <MoreVertical className='h-6 w-6' aria-hidden='true' />
          </Otherwise>
        </Choose>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className={twMerge("w-auto min-w-[120px]", className)}
        {...props}
      >
        <div className='flex-col py-1'>
          {children}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default OverflowMenu
